// extracted by mini-css-extract-plugin
module.exports = {"settingsContainer":"styles_settingsContainer__WZf6k","gameLinkImg":"styles_gameLinkImg__2oqZD","menuItem":"styles_menuItem__2xGct","paper":"styles_paper__26B1r"};